import axios from 'axios';
import { BASE_URL } from '@/config';

export const createClient = ({ baseURL }, store) => {
    const axiosInstance = axios.create({ baseURL, timeout: 5000 });
    axiosInstance.interceptors.response.use(
        response => response,
        error => {
            if (error.response && error.response.status >= 500) {
                import('@/store').then(({ default: store }) => {
                    store.dispatch('serverError', error);
                });
            }

            return Promise.reject(error);
        },
    );

    return axiosInstance;
};

export const defaultClient = createClient({ baseURL: BASE_URL });

export default defaultClient;
